import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// helper: inject subTenantId into request body if exists
const injectSubTenantId = (data) => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
    const jsonData = JSON.parse(data);
    jsonData.subTenantDTO = { id: decodedToken.subTenantId };
    return JSON.stringify(jsonData);
  }
  return data;
};

// common headers with conditional tenant-login
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": decodedToken?.tenantApiKey,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const AllergensApi = {
  // Create Allergens
  CreateAllergensApi: (data) => {
    data = injectSubTenantId(data);

    return apiApp
      .post(`/allergens`, data, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Update Allergens
  PutAllergensApi: (AllergensApiID, data) => {
    data = injectSubTenantId(data);

    return apiApp
      .put(`/allergens/${AllergensApiID}`, data, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List Allergens
  ListAllergensApi: (page, limit) => {
  return apiApp
    .get(
      `/allergens?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      { headers: getHeaders() }
    )
    .then((res) => res.data)
    .catch((err) => Promise.reject(err?.response?.data));
},

  // Single Allergens
  SingleAllergensApi: (AllergensApiID) => {
    return apiApp
      .get(
        `/allergens/${AllergensApiID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Delete Allergens
  DeleteAllergensApi: (AllergensApiID) => {
    return apiApp
      .delete(
        `/allergens/${AllergensApiID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default AllergensApi; 
